import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import UserInfoModal from '../utils/UserInfoModal';
import StatisticsPanel from './dashboard/StatisticsPanel';
import ChartPanel from './dashboard/ChartPanel';
import LicenzePanel from './dashboard/LicenzePanel';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  
  // Stato condiviso tra i pannelli
  const [activeTab, setActiveTab] = useState<'giornaliere' | 'settimanali'>('giornaliere');
  const [showComparison, setShowComparison] = useState(false);
  const [chartData, setChartData] = useState({
    dailyData: [] as any[],
    weeklyData: [] as any[],
    dailyDataPrevYear: [] as any[],
    weeklyDataPrevYear: [] as any[],
    isLoading: true,
    error: null as string | null
  });

  // Handler per aggiornare i dati del grafico
  const handleDataChange = (data: {
    dailyData: any[];
    weeklyData: any[];
    dailyDataPrevYear: any[];
    weeklyDataPrevYear: any[];
    isLoading: boolean;
    error: string | null;
  }) => {
    setChartData(data);
  };

  const handleLogout = () => {
    logout();
  };

  const handleReportClick = () => {
    navigate('/alimenti-personali');
  };

  const handleCommercialiClick = () => {
    navigate('/alimenti-commerciali');
  };

  const handleDieteClick = () => {
    navigate('/diete-personali');
  };

  const handleUserManagementClick = () => {
    navigate('/admin/users');
  };

  const handleChangePasswordClick = () => {
    navigate('/profile/change-password');
  };

  // Verifica se l'utente è admin
  const isAdmin = user?.ruoli?.some(role => 
    role?.toUpperCase() === 'ADMIN' || 
    role?.toUpperCase() === 'ADMINISTRATOR' ||
    role?.toLowerCase() === 'admin'
  ) || false;
  
  // Debug temporaneo - rimuovere dopo il test
  console.log('User roles:', user?.ruoli);
  console.log('Is admin:', isAdmin);

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <div className="header-content">
          <h1>MR Gestionale</h1>
          <div className="user-info">
            {isAdmin && (
              <button 
                className="admin-button" 
                onClick={handleUserManagementClick}
              >
                👥 Gestione Utenti
              </button>
            )}
            <button 
              className="user-name-button" 
              onClick={() => setIsUserModalOpen(true)}
            >
              {user?.nomeCompleto}
            </button>
            <button onClick={handleLogout} className="logout-button">
              Esci
            </button>
          </div>
        </div>
      </header>

      <main className="dashboard-main">
        <div className="dashboard-content">
          <div className="welcome-card">
            <h2>Dashboard</h2>
            <p>Benvenuto nel sistema MR Gestionale V2!</p>
          </div>

          <div className="dashboard-panels">
            <StatisticsPanel 
              activeTab={activeTab}
              onTabChange={setActiveTab}
              onDataChange={handleDataChange}
              onComparisonChange={setShowComparison}
            />
            <ChartPanel 
              dailyData={chartData.dailyData}
              weeklyData={chartData.weeklyData}
              dailyDataPrevYear={chartData.dailyDataPrevYear}
              weeklyDataPrevYear={chartData.weeklyDataPrevYear}
              activeTab={activeTab}
              showComparison={showComparison}
              isLoading={chartData.isLoading}
              error={chartData.error}
            />
          </div>

          {/* Pannello Licenze */}
          <div className="dashboard-panels">
            <LicenzePanel />
          </div>

          <div className="welcome-card">
            <div className="quick-actions">
              <h3>Osservatorio</h3>
              <div className="actions-grid">
                <button className="action-button" onClick={handleReportClick}>
                  📊 Alimenti Personali
                </button>
                <button className="action-button" onClick={handleCommercialiClick}>
                  🏪 Alimenti Commerciali
                </button>
                <button className="action-button" onClick={handleDieteClick}>
                  🥗 Conteggio Diete Personali
                </button>
                <button className="action-button" disabled>
                  📈 Analytics
                </button>
              </div>
              <p className="coming-soon">
                Altre funzionalità in arrivo...
              </p>
            </div>
          </div>
        </div>
      </main>
      
      <UserInfoModal 
        isOpen={isUserModalOpen}
        onClose={() => setIsUserModalOpen(false)}
        user={user}
      />
    </div>
  );
};

export default Dashboard;